<script setup>
  import { computed } from "vue";
  import { useChartPreview } from "../composables/useChartPreview";

  const props = defineProps({
    colors: { type: Array, required: true },
    width: { type: Number, required: true },
    height: { type: Number, required: true },
    padding: { type: Number, required: true },
    seriesCount: { type: Number, required: true },
    categoryCount: { type: Number, required: true },
  });

  const { chartWidth, chartHeight, displayColors, getValue } = useChartPreview(props);

  const clusteredGroupGap = 8;

  const categorySpacing = computed(() => {
    const totalGaps = (props.categoryCount - 1) * clusteredGroupGap;
    return (chartHeight.value - totalGaps) / props.categoryCount + clusteredGroupGap;
  });

  const clusteredBarHeight = computed(() => {
    const groupHeight = categorySpacing.value - clusteredGroupGap;
    return Math.max(4, groupHeight / props.seriesCount);
  });

  function getBarWidth(catIdx, seriesIdx) {
    return chartWidth.value * getValue(catIdx, seriesIdx);
  }
</script>

<template>
  <g
    v-for="(cat, catIdx) in categoryCount"
    :key="catIdx">
    <rect
      v-for="(series, seriesIdx) in seriesCount"
      :key="seriesIdx"
      :x="padding"
      :y="padding + catIdx * categorySpacing + seriesIdx * clusteredBarHeight"
      :width="getBarWidth(catIdx, seriesIdx)"
      :height="clusteredBarHeight - 1"
      :fill="displayColors[seriesIdx % displayColors.length]"
      rx="1" />
  </g>
</template>
